import React from 'react';

import { ScaffolderFormHeader } from './ScaffolderFormHeader';

interface ScaffolderInputHeaderProps {
  title: string;
  description: string;
  variant?: 'body1' | 'body2';
  infoDoc?: string;
}

export const ScaffolderInputHeader = (props: ScaffolderInputHeaderProps) => {
  const { title, description, variant = 'body2', infoDoc } = props;

  return (
    <ScaffolderFormHeader
      title={title}
      description={description}
      variant={variant}
      infoDoc={infoDoc}
    />
  );
};
